import { render, staticRenderFns } from "./newsletterJ.vue?vue&type=template&id=043a828e"
import script from "./newsletterJ.vue?vue&type=script&lang=js"
export * from "./newsletterJ.vue?vue&type=script&lang=js"
import style0 from "./newsletterJ.vue?vue&type=style&index=0&id=043a828e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports